/**
 * @module SharedModule
 * @description
 * This is the shared module of the application.
 * It contain the application related dependencies that can be shared across the applications
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import MaterialComponentsModule from '@app/modules/theme/material-components.module';
import { NoRecordFoundComponent } from './no-record-found/no-record-found.component';
import { ConfirmModalComponent } from './shared-modal/confirm-modal/confirm-modal.component';
import { BidConfirmComponent } from './shared-modal/bid-confirm/bid-confirm.component';
import { ConfirmResolveDisputeComponent } from './shared-modal/confirm-resolve-dispute/confirm-resolve-dispute.component';
import { CarrierProfileComponent } from './components/carrier-profile/carrier-profile.component';
import { ShipperProfileComponent } from './components/shipper-profile/shipper-profile.component';
import { CommonModule } from '@angular/common';
import { SupportHelpComponent } from './components/support-help/support-help.component';
import { NgxStarsModule } from 'ngx-stars';
import { NgChartsModule } from 'ng2-charts';
import { AssignedStaffComponent } from './components/assigned-staff/assigned-staff.component';
import { LoaderComponent } from './components/loader/loader.component';
import { ChatBoxComponent } from './components/chat-box/chat-box.component';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from '@danielmoncada/angular-datetime-picker';
import { FilterComponent } from './components/load table filter/filter/filter.component';
import { UpdateSubscriptionComponent } from './components/update-subscription/update-subscription.component';
import { NgxStripeModule } from 'ngx-stripe';
import { StripePaymentService } from '@app/modules/account/service/stripe.service';
import { UpdateSubscriptionPaymentComponent } from './components/update-subscription-payment/update-subscription-payment.component';
import { CommanProfileComponent } from './components/comman-profile/comman-profile.component';
import { ReferenceNumberPopupComponent } from './components/reference-number-popup/reference-number-popup.component';
import { WeightKgToLbs } from './custom pipes/weightKgToLbs.pipe';
import { FileTypeIconPipe } from './custom pipes/file-type-icon.pipe';
import { FileDisplayNamePipe } from './custom pipes/file-display-name.pipe';
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { OwlMomentDateTimeModule } from '@danielmoncada/angular-datetime-picker-moment-adapter';
import { MapLoadListComponent } from './components/map-load-list/map-load-list.component';
import { LoadRouteMarkersComponent } from './components/load-route-markers/load-route-markers.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { EditLeaveDialogComponent } from '@app/modules/carrier/components/drivers/edit-leave-dialog/edit-leave-dialog.component';
import { StatusChipComponent } from './components/status-chip/status-chip.component';
import { CustomPaginationComponent } from './components/custom-pagination/custom-pagination.component';
import { AccessorialDocumentsModalComponent } from './components/accessorial-documents-modal/accessorial-documents-modal.component';
import { SubscriptionStatusComponent } from './components/subscription-status/subscription-status.component';
import { SubscriptionPaymentTabComponent } from './components/subscription-payment-tab/subscription-payment-tab.component';
import { UpdateCardDialogComponent } from './components/update-card-dialog/update-card-dialog.component';

@NgModule({
   declarations: [
      NoRecordFoundComponent,
      ConfirmModalComponent,
      BidConfirmComponent,
      ConfirmResolveDisputeComponent,
      CarrierProfileComponent,
      ShipperProfileComponent,
      AssignedStaffComponent,
      LoaderComponent,
      ChatBoxComponent,
      FilterComponent,
      MapLoadListComponent,
      LoadRouteMarkersComponent,
      UpdateSubscriptionComponent,
      UpdateSubscriptionPaymentComponent,
      CommanProfileComponent,
      ReferenceNumberPopupComponent,
      WeightKgToLbs,
      FileTypeIconPipe,
      FileDisplayNamePipe,
      ConfirmDialogComponent,
      EditLeaveDialogComponent,
      StatusChipComponent,
      CustomPaginationComponent,
      AccessorialDocumentsModalComponent,
      SubscriptionStatusComponent,
      SubscriptionPaymentTabComponent,
      UpdateCardDialogComponent
   ],
   imports: [
      FormsModule,
      CommonModule,
      SupportHelpComponent,
      ReactiveFormsModule,
      MaterialComponentsModule,
      OwlDateTimeModule,
      OwlMomentDateTimeModule,
      OwlNativeDateTimeModule,
      InfiniteScrollModule,
      NgxStripeModule.forRoot('pk_test_51HS27CGULtR73YOeci3Ls3Dw99rONWrGfoI29hgacBtOQpBoOjbmRMvDviOlwdChgblN0ACSe27GqzIF9yfarNcL00s4JJvTFW'),
      NgxStarsModule,
      NgChartsModule,
      GoogleMapsModule  
   ],
   exports: [
      NoRecordFoundComponent,
      LoaderComponent,
      NgChartsModule,
      FormsModule,
      NgxStarsModule,
      ReactiveFormsModule,
      MaterialComponentsModule,
      ShipperProfileComponent,
      CarrierProfileComponent,
      CommanProfileComponent,
      AssignedStaffComponent,
      CommonModule,
      FilterComponent,
      MapLoadListComponent,
      LoadRouteMarkersComponent,
      ChatBoxComponent,
      WeightKgToLbs,
      FileTypeIconPipe,
      FileDisplayNamePipe,
      ConfirmDialogComponent,
      EditLeaveDialogComponent,
      StatusChipComponent,
      CustomPaginationComponent,
      AccessorialDocumentsModalComponent,
      SubscriptionStatusComponent,
      SubscriptionPaymentTabComponent
   ],
   providers: [
      StripePaymentService
   ],
   schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule { }
